import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';
import {
  BIA,
  BIA_PAGE_TYPE,
  BIA_PAGE_NAME_PAGINATION,
  BIA_CATEGORY,
  BIA_SUBCATEGORY1,
  BIA_SUBCATEGORY2_PAGINATION
} from '../../../constants';

export function buyItAgain() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('buyItAgain.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: BIA_SUBCATEGORY1,
        pageType: BIA_PAGE_TYPE
      },
      category: {
        primaryCategory: BIA,
        subCategory1: BIA,
        subCategory2: BIA

      }
    };
    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('buy-it-again.pagePagination', () => {
    digitalData.page = {
      pageInfo: {
        pageName: BIA_PAGE_NAME_PAGINATION,
        pageType: BIA_PAGE_TYPE,
      },
      category: {
        primaryCategory: BIA_CATEGORY,
        subCategory1: BIA_SUBCATEGORY1,
        subCategory2: BIA_SUBCATEGORY2_PAGINATION
      },
    };
    setAnalytics(digitalData);
  });
}
